// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cp7mT8xGYhMPie {
  scroll-margin: 8px;
}
.cp7mT8xGYhMPie.whxC0_EOm66H7F {
  margin: 8px var(--ds-space-0, 0);
}
.cp7mT8xGYhMPie.whxC0_EOm66H7F:last-child {
  margin: 8px var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.QnC5HZJq_5Juhe {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  border-radius: var(--ds-border-radius-100, 3px);
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  height: auto;
  min-height: 36px;
  max-height: 160px;
  margin: var(--ds-space-0, 0);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 8px 12px;
  overflow: hidden;
  overflow-y: auto;
  border: none;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  resize: none;
  overflow-wrap: break-word;
}
.QnC5HZJq_5Juhe:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.QnC5HZJq_5Juhe:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.QnC5HZJq_5Juhe:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.QnC5HZJq_5Juhe[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.QnC5HZJq_5Juhe.tS_nrecDbHXG9H {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.QnC5HZJq_5Juhe.tS_nrecDbHXG9H:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.QnC5HZJq_5Juhe.tS_nrecDbHXG9H:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.QnC5HZJq_5Juhe.OQCKZnyhkPqi9A {
  width: 100%;
}
.QnC5HZJq_5Juhe::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.QnC5HZJq_5Juhe:focus {
  outline: none;
}
.QnC5HZJq_5Juhe:hover {
  min-height: 36px;
  max-height: 160px;
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.mAnpPnqo0kVz5C {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  gap: 4px;
  margin-top: 8px;
}
.mAnpPnqo0kVz5C button {
  margin: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var container = `cp7mT8xGYhMPie`;
export var hoverGapEnabled = `whxC0_EOm66H7F`;
export var cardComposer = `QnC5HZJq_5Juhe`;
var _1 = `tS_nrecDbHXG9H`;
export { _1 as "input-error" };
export var full = `OQCKZnyhkPqi9A`;
export var cardComposerSubmit = `mAnpPnqo0kVz5C`;
export default ___CSS_LOADER_EXPORT___;
